/* ============================================================
   Elaya Jewels — theme.js  (static asset, NO Liquid tags)
   ============================================================ */

/* ── Global cart object (outside DOMContentLoaded so onclick= works) ── */
window.ElayaCart = {
  threshold: 99900,   /* ₹999 in paise */

  open: function () {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    var scrollY = window.scrollY;
    document.documentElement.style.setProperty('--scroll-y', '-' + scrollY + 'px');
    document.body.classList.add('drawer-open');
    d.classList.add('open');
    /* Fetch cart, cache stock for all variants, then hide upsell */
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      window.ElayaCart.hideUpsellInCart(cart);
      /* Pre-cache stock for all tracked variants */
      cart.items.forEach(function(item){
        if (item.inventory_management && item.inventory_policy !== 'continue') {
          fetch('/variants/' + item.variant_id + '.js')
            .then(function(r){ return r.json(); })
            .then(function(v){
              if (!window.__variantStock) window.__variantStock = {};
              window.__variantStock[String(v.id)] = v.inventory_quantity;
              /* Update the + button stock cap live */
              document.querySelectorAll('.cart-item__qty-btn[data-action="plus"]').forEach(function(btn){
                if (btn.closest('.cart-item')) {
                  var titleEl = btn.closest('.cart-item').querySelector('.cart-item__title');
                  if (titleEl && item.handle && titleEl.href && titleEl.href.indexOf(item.handle) !== -1) {
                    btn.dataset.stock = v.inventory_quantity;
                  }
                }
              });
            }).catch(function(){});
        }
      });
    });
  },

  close: function () {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    d.classList.remove('open');
    /* Restore scroll position */
    var scrollY = document.body.style.top;
    document.body.classList.remove('drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  },

  refresh: function () {
    var body = document.getElementById('cart-drawer-body');
    if (body) { body.style.opacity = '0.45'; body.style.pointerEvents = 'none'; }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (body) { body.style.opacity = '1'; body.style.pointerEvents = ''; }
        document.querySelectorAll('.cart-count-badge, #cart-count-drawer').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var sub = document.getElementById('cart-subtotal-drawer');
        if (sub) sub.textContent = window.ElayaCart.money(cart.total_price);
        var tot = document.getElementById('cart-total-drawer');
        if (tot) tot.textContent = window.ElayaCart.money(cart.total_price);
        window.ElayaCart.shipBar(cart.total_price);
        var lbl = document.getElementById('cart-items-label');
        if (lbl) lbl.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
        /* Fetch live stock for all tracked variants in cart */
        var variantIds = cart.items
          .filter(function(i){ return i.inventory_management && i.inventory_policy !== 'continue'; })
          .map(function(i){ return i.variant_id; });
        if (variantIds.length) {
          var stockPromises = variantIds.map(function(vid){
            return fetch('/variants/' + vid + '.js')
              .then(function(r){ return r.json(); })
              .then(function(v){
                if (!window.__variantStock) window.__variantStock = {};
                window.__variantStock[String(v.id)] = v.inventory_quantity;
              }).catch(function(){});
          });
          Promise.all(stockPromises).then(function(){
            window.ElayaCart.renderItems(cart);
            window.ElayaCart.hideUpsellInCart(cart);
          });
        } else {
          window.ElayaCart.renderItems(cart);
          window.ElayaCart.hideUpsellInCart(cart);
        }
      })
      .catch(function () {
        if (body) { body.style.opacity = '1'; body.style.pointerEvents = ''; }
      });
  },

  hideUpsellInCart: function(cart) {
    var cartVariantIds = cart.items.map(function(i){ return String(i.variant_id); });
    document.querySelectorAll('.cart-upsell__card').forEach(function(card) {
      var btn = card.querySelector('.cart-upsell__atc');
      if (btn && cartVariantIds.indexOf(String(btn.dataset.variantId)) !== -1) {
        card.style.display = 'none';
      } else if (btn) {
        card.style.display = '';
      }
    });
  },

  money: function (cents) {
    return '₹' + (cents / 100).toFixed(2);
  },

  shipBar: function (paise) {
    var fill = document.getElementById('ship-fill');
    var msg  = document.getElementById('ship-msg');
    if (!fill || !msg) return;
    var pct = Math.min(100, Math.round(paise / window.ElayaCart.threshold * 100));
    fill.style.width = pct + '%';
    if (paise >= window.ElayaCart.threshold) {
      fill.style.background = 'linear-gradient(90deg,#2ecc71,#1a8a4a)';
      msg.innerHTML = '<strong style="color:#2e8b6a;">🎉 You qualify for free shipping!</strong>';
    } else {
      var rem = window.ElayaCart.threshold - paise;
      fill.style.background = 'linear-gradient(90deg,#dfc98a,#b8922e)';
      msg.innerHTML = 'Add <strong>' + window.ElayaCart.money(rem) + '</strong> more for free shipping';
    }
  },

  renderItems: function (cart) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<p style="text-align:center;padding:52px 0;color:var(--text-muted);font-size:1.4rem;font-family:var(--font-sans);">Your cart is empty 🛍</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, idx) {
      var stock = 9999;
      if (item.inventory_management && item.inventory_policy !== 'continue') {
        /* Use cached live stock if available */
        if (window.__variantStock && window.__variantStock[String(item.variant_id)] !== undefined) {
          stock = window.__variantStock[String(item.variant_id)];
        } else if (typeof item.variant_inventory_quantity === 'number') {
          stock = item.variant_inventory_quantity;
        }
        /* Cross-check with page-level product data if on product page */
        if (window.__productVariants) {
          var pv = window.__productVariants.find(function(v){ return String(v.id) === String(item.variant_id); });
          if (pv && typeof pv.inventory_quantity === 'number') {
            stock = Math.min(stock === 9999 ? pv.inventory_quantity : stock, pv.inventory_quantity);
          }
        }
        /* Never cap below current quantity */
        if (stock < item.quantity) stock = item.quantity;
      }
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" style="width:80px;height:100px;object-fit:cover;background:var(--off-white);flex-shrink:0;border:1px solid var(--border);">'
        : '<div style="width:80px;height:100px;background:var(--off-white);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:2.4rem;opacity:.3;">💎</div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-item__variant">' + item.variant_title + '</span>' : '';
      html += '<div class="cart-item">' +
        imgHtml +
        '<div class="cart-item__info">' +
          '<a href="' + item.url + '" class="cart-item__title">' + (item.product_title || item.title) + '</a>' +
          variant +
          '<p class="cart-item__price">' + window.ElayaCart.money(item.final_price) + '</p>' +
          '<div class="cart-item__qty">' +
            '<button class="cart-item__qty-btn" data-action="minus" data-line="' + (idx + 1) + '" data-qty="' + item.quantity + '">−</button>' +
            '<span class="cart-item__qty-num">' + item.quantity + '</span>' +
            '<button class="cart-item__qty-btn" data-action="plus" data-line="' + (idx + 1) + '" data-qty="' + item.quantity + '" data-stock="' + stock + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="cart-item__remove" data-line="' + (idx + 1) + '" aria-label="Remove" title="Remove">' +
          '<svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>';
    });
    body.innerHTML = html;
  }
};

/* ── Global inline callbacks (must be on window) ── */
window.saveCartNote = function (val) {
  fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: val }) });
};
window.applyDrawerDiscount = function () {
  var inp = document.getElementById('drawer-discount-input');
  if (inp && inp.value.trim()) window.location.href = '/checkout?discount=' + encodeURIComponent(inp.value.trim());
};
window.drawerCheckout = function (e) {
  var cb = document.getElementById('cart-tnc-cb');
  if (cb && !cb.checked) {
    e.preventDefault();
    var lbl = cb.closest('.cart-tnc');
    if (lbl) { lbl.style.outline = '2px solid var(--red)'; lbl.style.outlineOffset = '4px'; setTimeout(function () { lbl.style.outline = ''; }, 2200); }
    return;
  }
  window.location.href = '/checkout';
};
window.toggleDrawerGiftWrap = function (cb) {
  var lbl = document.getElementById('drawer-gift-label');
  if (lbl) {
    lbl.style.borderColor = cb.checked ? 'var(--gold)' : 'var(--border)';
    lbl.style.background  = cb.checked ? 'var(--off-white)' : '#fff';
  }

  var giftVid = window.__giftWrapVariantId;

  if (giftVid) {
    if (cb.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftVid, quantity: 1 })
      }).then(function(){ window.ElayaCart.refresh(); });
    } else {
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        cart.items.forEach(function(item, idx){
          if (String(item.variant_id) === String(giftVid)) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: idx + 1, quantity: 0 })
            }).then(function(){ window.ElayaCart.refresh(); });
          }
        });
      });
    }
  } else {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift Wrap': cb.checked ? 'Yes' : '' } })
    }).then(function(){ window.ElayaCart.refresh(); });
    if (cb.checked) {
      var sub = document.getElementById('cart-subtotal-drawer');
      if (sub) sub.insertAdjacentHTML('afterend', '<p id="gift-wrap-note" style="font-size:1.1rem;color:var(--gold);margin-top:4px;">+₹99 gift wrap added at checkout</p>');
    } else {
      var note = document.getElementById('gift-wrap-note');
      if (note) note.remove();
    }
  }
};

/* ══════════════════════════════════════════════
   DOM-ready
   ══════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Fade-up scroll reveal ── */
  var fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
    fadeEls.forEach(function (el) { io.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── Cart open / close ── */
  document.querySelectorAll('#cart-toggle, #cart-toggle-mobile').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); window.ElayaCart.open(); });
  });
  var ov = document.getElementById('cart-overlay');
  var cl = document.getElementById('cart-close');
  if (ov) ov.addEventListener('click', window.ElayaCart.close);
  if (cl) cl.addEventListener('click', window.ElayaCart.close);

  /* ── Drawer qty +/- and remove (event delegation) ── */
  var drawerBody = document.getElementById('cart-drawer-body');
  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var qBtn = e.target.closest('.cart-item__qty-btn');
      var rBtn = e.target.closest('.cart-item__remove');

      if (qBtn) {
        var line   = parseInt(qBtn.dataset.line);
        var qty    = parseInt(qBtn.dataset.qty);
        var action = qBtn.dataset.action;

        if (action === 'plus') {
          var plusBtn  = qBtn;
          var maxStock = parseInt(plusBtn.dataset.stock || '9999');
          if (qty >= maxStock) {
            var qWrap = plusBtn.closest('.cart-item__qty');
            var existing = qWrap && qWrap.parentNode.querySelector('.cart-stock-msg');
            if (!existing) {
              var msg = document.createElement('p');
              msg.className = 'cart-stock-msg';
              msg.textContent = 'Max ' + maxStock + ' available';
              msg.style.cssText = 'font-size:1.35rem;font-weight:600;color:var(--red);margin-top:6px;font-family:var(--font-sans);padding:8px 12px;background:#fff0f0;border:1px solid var(--red);border-radius:2px;';
              qWrap.parentNode.appendChild(msg);
              setTimeout(function(){ if (msg.parentNode) msg.parentNode.removeChild(msg); }, 2500);
            }
            return;
          }
        }

        var newQty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);

        /* Optimistic update */
        var qNum = qBtn.parentNode.querySelector('.cart-item__qty-num');
        if (qNum) qNum.textContent = newQty;
        qBtn.parentNode.querySelectorAll('.cart-item__qty-btn').forEach(function(b){ b.dataset.qty = newQty; });

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          document.querySelectorAll('.cart-count-badge, #cart-count-drawer').forEach(function(el){ el.textContent = cart.item_count; });
          var lbl = document.getElementById('cart-items-label');
          if (lbl) lbl.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
          var sub = document.getElementById('cart-subtotal-drawer'); if (sub) sub.textContent = window.ElayaCart.money(cart.total_price);
          var tot = document.getElementById('cart-total-drawer');    if (tot) tot.textContent = window.ElayaCart.money(cart.total_price);
          window.ElayaCart.shipBar(cart.total_price);
          var serverItem = cart.items[line - 1];
          if ((serverItem && serverItem.quantity < newQty) || newQty === 0) {
            /* Re-fetch fresh cart to avoid stale prices / NA issue */
            fetch('/cart.js').then(function(r){ return r.json(); }).then(function(freshCart){
              window.ElayaCart.renderItems(freshCart);
              window.ElayaCart.hideUpsellInCart(freshCart);
            });
          }
        });
      }

      if (rBtn) {
        var item = rBtn.closest('.cart-item');
        if (item) { item.style.opacity = '0.3'; item.style.pointerEvents = 'none'; }

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(rBtn.dataset.line), quantity: 0 })
        })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          document.querySelectorAll('.cart-count-badge, #cart-count-drawer').forEach(function(el){ el.textContent = cart.item_count; });
          var sub = document.getElementById('cart-subtotal-drawer'); if (sub) sub.textContent = window.ElayaCart.money(cart.total_price);
          var tot = document.getElementById('cart-total-drawer');    if (tot) tot.textContent = window.ElayaCart.money(cart.total_price);
          window.ElayaCart.shipBar(cart.total_price);
          window.ElayaCart.renderItems(cart);
          window.ElayaCart.hideUpsellInCart(cart);
        });
      }
    });
  }

  /* Initial ship bar */
  var cartTotalEl = document.getElementById('cart-total-init');
  var initTotal = cartTotalEl ? parseInt(cartTotalEl.dataset.total || '0') : (window.__cartTotal || 0);
  window.ElayaCart.shipBar(initTotal);

  /* ── Quick-add from product cards ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add-btn, .pc__atc');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var vid = btn.dataset.variantId;
    if (!vid) return;

    btn.disabled = true;
    var orig = btn.textContent;

    window.ElayaCart.open();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      window.ElayaCart.refresh();
      btn.textContent = '✓';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1200);
    })
    .catch(function () { btn.textContent = orig; btn.disabled = false; });
  });

  /* ── Product page qty — with stock cap ── */
  var qMinus = document.getElementById('qty-minus');
  var qPlus  = document.getElementById('qty-plus');
  var qInput = document.getElementById('qty-input');

  function getProductStock() {
    var vid = document.getElementById('variant-id');
    if (!vid || !window.__productVariants) return 9999;
    var v = window.__productVariants.find(function(v){ return String(v.id) === String(vid.value); });
    if (!v) return 9999;
    if (!v.inventory_management || v.inventory_policy === 'continue') return 9999;
    return typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 9999;
  }

  function showProdStockMsg(max) {
    var old = document.getElementById('prod-stock-msg');
    if (old) old.remove();
    var msg = document.createElement('p');
    msg.id = 'prod-stock-msg';
    msg.textContent = max <= 0 ? 'This item is out of stock' : 'Only ' + max + ' available — max quantity reached';
    msg.style.cssText = 'font-size:1.25rem;color:var(--red);margin-top:8px;font-family:var(--font-sans);font-weight:500;';
    var atcRow = document.querySelector('.atc-row');
    if (atcRow) atcRow.insertAdjacentElement('afterend', msg);
    setTimeout(function(){ var m = document.getElementById('prod-stock-msg'); if(m) m.remove(); }, 3500);
  }

  if (qPlus && qInput) {
    qPlus.addEventListener('click', function() {
      var max = getProductStock();
      var cur = parseInt(qInput.value) || 1;
      if (cur >= max) { showProdStockMsg(max); return; }
      qInput.value = cur + 1;
    });
  }
  if (qMinus && qInput) {
    qMinus.addEventListener('click', function() {
      if (parseInt(qInput.value) > 1) qInput.value = parseInt(qInput.value) - 1;
    });
  }

  /* ── Product page ATC — stock check BEFORE fetch ── */
  var pForm = document.getElementById('product-form');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn    = document.getElementById('atc-btn');
      if (btn && btn.disabled) return;
      var vid    = document.getElementById('variant-id');
      var qtyEl  = document.getElementById('qty-input');
      var qtyVal = qtyEl ? parseInt(qtyEl.value) || 1 : 1;

      var max = getProductStock();
      if (qtyVal > max) {
        showProdStockMsg(max);
        return;
      }

      if (btn) btn.disabled = true;
      var orig = btn ? btn.textContent : '';

      window.ElayaCart.open();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid ? vid.value : '', quantity: qtyVal })
      })
      .then(function() {
        window.ElayaCart.refresh();
        if (btn) { btn.textContent = '\u2713 Added!'; btn.style.background = 'var(--green)'; btn.style.borderColor = 'var(--green)'; }
        setTimeout(function() {
          if (btn) { btn.textContent = orig; btn.style.background = ''; btn.style.borderColor = ''; btn.disabled = false; }
        }, 1800);
      })
      .catch(function() { if (btn) { btn.textContent = orig; btn.disabled = false; } });
    });
  }

  /* ── Gallery thumbs (desktop) ── */
  var thumbEls  = Array.from(document.querySelectorAll('.gallery-thumb'));
  var deskIdx   = 0;

  function setDesktopImage(idx) {
    if (!thumbEls.length) return;
    var clamped = (idx + thumbEls.length) % thumbEls.length;
    deskIdx = clamped;
    thumbEls.forEach(function(t){ t.classList.remove('on'); });
    thumbEls[clamped].classList.add('on');
    var mainImg = document.getElementById('main-img');
    var full    = thumbEls[clamped].getAttribute('data-full');
    if (mainImg && full) {
      mainImg.style.opacity = '0';
      mainImg.src = full;
      mainImg.onload = function () { mainImg.style.opacity = '1'; };
    }
  }

  thumbEls.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { setDesktopImage(i); });
  });

  var dp = document.getElementById('desk-prev');
  var dn = document.getElementById('desk-next');
  if (dp) dp.addEventListener('click', function(){ setDesktopImage(deskIdx - 1); });
  if (dn) dn.addEventListener('click', function(){ setDesktopImage(deskIdx + 1); });

  /* ── Gallery swipe (mobile) ── */
  var swipe = document.getElementById('gallery-swipe');
  var dots  = document.querySelectorAll('.gallery-dot');
  if (swipe && dots.length) {
    swipe.addEventListener('scroll', function () {
      var idx = Math.round(swipe.scrollLeft / swipe.offsetWidth);
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    }, { passive: true });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(this.dataset.index);
        swipe.scrollTo({ left: idx * swipe.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  /* ── Image lightbox ── */
  var lightbox      = document.getElementById('img-lightbox');
  var lightboxImg   = document.getElementById('lightbox-img');
  var lightboxClose = document.getElementById('lightbox-close');

  function openLightbox(src) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightbox.classList.add('open');
    document.body.classList.add('drawer-open');
    document.documentElement.style.setProperty('--scroll-y', '-' + window.scrollY + 'px');
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    var scrollY = document.body.style.top;
    document.body.classList.remove('drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  var zoomDesktop = document.getElementById('zoom-btn-desktop');
  if (zoomDesktop) {
    zoomDesktop.addEventListener('click', function () {
      var mainImg = document.getElementById('main-img');
      if (mainImg) openLightbox(mainImg.src);
    });
  }

  var zoomMobile = document.getElementById('zoom-btn-mobile');
  if (zoomMobile && swipe) {
    zoomMobile.addEventListener('click', function () {
      var idx     = Math.round(swipe.scrollLeft / swipe.offsetWidth);
      var imgs    = swipe.querySelectorAll('.gallery-swipe__img');
      var current = imgs[idx] || imgs[0];
      var src = (window.__galleryImages && window.__galleryImages[idx]) ? window.__galleryImages[idx] : (current ? current.src : '');
      if (src) openLightbox(src);
    });
  }

  /* ── Product tabs ── */
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var t = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('on'); });
      document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('on'); });
      this.classList.add('on');
      var panel = document.getElementById('tab-' + t);
      if (panel) panel.classList.add('on');
    });
  });

  /* ── Variant selectors ── */
  document.querySelectorAll('.color-sw').forEach(function (sw) {
    sw.addEventListener('click', function () {
      this.closest('.color-swatches').querySelectorAll('.color-sw').forEach(function (s) { s.classList.remove('on'); });
      this.classList.add('on');
      updateVariant();
    });
  });
  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.closest('.size-btns').querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('on'); });
      this.classList.add('on');
      updateVariant();
    });
  });
  function updateVariant() {
    var selected = [];
    document.querySelectorAll('[data-option]').forEach(function (g) {
      var a = g.querySelector('.on');
      if (a) selected.push(a.dataset.value || a.textContent.trim());
    });
    var vd = window.__productVariants;
    if (!vd) return;
    var match = vd.find(function (v) { return v.options.every(function (o, i) { return selected[i] === undefined || o === selected[i]; }); });
    if (match) {
      var vid = document.getElementById('variant-id'); if (vid) vid.value = match.id;
      var pe  = document.getElementById('prod-price'); if (pe)  pe.textContent = window.ElayaCart.money(match.price);
    }
  }

  /* ── Mobile nav ── */
  var hamburger   = document.getElementById('hamburger');
  var mobileNav   = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');
  var mobileBg    = document.getElementById('mobile-nav-bg');
  if (hamburger)   hamburger.addEventListener('click',   function () { if (mobileNav) mobileNav.classList.add('open'); });
  if (mobileClose) mobileClose.addEventListener('click', function () { if (mobileNav) mobileNav.classList.remove('open'); });
  if (mobileBg)    mobileBg.addEventListener('click',    function () { if (mobileNav) mobileNav.classList.remove('open'); });

  /* ── Wishlist (localStorage) ── */
  var wl = [];
  try { wl = JSON.parse(localStorage.getItem('elaya_wl') || '[]'); } catch (e) {}
  document.querySelectorAll('.wish-btn, .pc__wish').forEach(function (btn) {
    var id = btn.dataset.id;
    if (!id) return;
    if (wl.indexOf(id) > -1) btn.classList.add('wishlisted');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (wl.indexOf(id) > -1) { wl = wl.filter(function (x) { return x !== id; }); btn.classList.remove('wishlisted'); }
      else                      { wl.push(id); btn.classList.add('wishlisted'); }
      try { localStorage.setItem('elaya_wl', JSON.stringify(wl)); } catch (e2) {}
    });
  });

  /* ── Bundle ── */
  var bundleBox = document.getElementById('bundle-box');
  if (bundleBox) {
    var disc = parseFloat(bundleBox.dataset.discount || 0) / 100;
    function calcBundle() {
      var total = 0;
      document.querySelectorAll('.bundle-check.on').forEach(function (c) { total += parseInt(c.dataset.price || 0); });
      var ow = document.getElementById('bundle-was');   if (ow) ow.textContent = window.ElayaCart.money(total);
      var dp = document.getElementById('bundle-price'); if (dp) dp.textContent = window.ElayaCart.money(Math.round(total * (1 - disc)));
    }
    document.querySelectorAll('.bundle-check').forEach(function (c) { c.addEventListener('click', function () { this.classList.toggle('on'); calcBundle(); }); });
    calcBundle();
    var addBundle = document.getElementById('add-bundle');
    if (addBundle) {
      addBundle.addEventListener('click', function () {
        var items = [];
        document.querySelectorAll('.bundle-check.on').forEach(function (c) { if (c.dataset.variantId) items.push({ id: c.dataset.variantId, quantity: 1 }); });
        if (!items.length) return;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function () { window.ElayaCart.open(); });
      });
    }
  }

  /* ── Live viewer count ── */
  var viewerEl = document.getElementById('viewer-count');
  if (viewerEl) {
    var v = parseInt(viewerEl.textContent) || 12;
    setInterval(function () { v = Math.max(3, v + (Math.random() > 0.5 ? 1 : -1)); viewerEl.textContent = v; }, 8000);
  }

  /* ── Cart PAGE qty stepper & remove ── */
  document.querySelectorAll('.cp-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.textContent = '…'; btn.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: btn.dataset.line, quantity: 0 }) })
        .then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('.cp-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line     = btn.dataset.line;
      var qty      = parseInt(btn.dataset.qty);
      var maxStock = parseInt(btn.dataset.stock || '9999');
      if (qty >= maxStock) {
        var existing = btn.closest('.cp-stepper').parentNode.querySelector('.cp-stock-msg');
        if (!existing) {
          var msg = document.createElement('span');
          msg.className = 'cp-stock-msg';
          msg.textContent = 'Max ' + maxStock;
          msg.style.cssText = 'font-size:1.1rem;color:var(--red);font-family:var(--font-sans);';
          btn.closest('.cp-stepper').after(msg);
          setTimeout(function () { if (msg.parentNode) msg.remove(); }, 2500);
        }
        return;
      }
      var newQty = qty + 1;
      btn.dataset.qty = newQty;
      btn.closest('.cp-stepper').querySelector('.cp-minus').dataset.qty = newQty;
      var numEl = document.getElementById('cp-num-' + line);
      if (numEl) numEl.textContent = newQty;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: newQty }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cart.items.forEach(function (item, i) {
            var lineEl = document.getElementById('cp-line-' + (i + 1));
            if (lineEl) lineEl.textContent = window.ElayaCart.money(item.final_line_price);
          });
          var sub = document.getElementById('cp-subtotal'); if (sub) sub.textContent = window.ElayaCart.money(cart.total_price);
          var tot = document.getElementById('cp-total');    if (tot) tot.textContent = window.ElayaCart.money(cart.total_price);
        });
    });
  });

  document.querySelectorAll('.cp-minus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line   = btn.dataset.line;
      var qty    = parseInt(btn.dataset.qty);
      var newQty = Math.max(0, qty - 1);
      btn.dataset.qty = newQty;
      btn.closest('.cp-stepper').querySelector('.cp-plus').dataset.qty = newQty;
      var numEl = document.getElementById('cp-num-' + line);
      if (numEl) numEl.textContent = newQty || '0';
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: newQty }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (newQty === 0) { window.location.reload(); return; }
          cart.items.forEach(function (item, i) {
            var lineEl = document.getElementById('cp-line-' + (i + 1));
            if (lineEl) lineEl.textContent = window.ElayaCart.money(item.final_line_price);
          });
          var sub = document.getElementById('cp-subtotal'); if (sub) sub.textContent = window.ElayaCart.money(cart.total_price);
          var tot = document.getElementById('cp-total');    if (tot) tot.textContent = window.ElayaCart.money(cart.total_price);
        });
    });
  });

  /* ── Discount popup ── */
  (function () {
    var pop = document.getElementById('discount-popup');
    if (!pop) return;
    function getCookie(n) { var m = document.cookie.match('(^| )' + n + '=([^;]+)'); return m ? m[2] : null; }
    function setCookie(n, v, d) { var x = new Date(); x.setTime(x.getTime() + d * 864e5); document.cookie = n + '=' + v + ';expires=' + x.toUTCString() + ';path=/'; }
    if (!getCookie('elaya_pop')) {
      setTimeout(function () { pop.classList.add('show'); }, 25000);
    }
    function closePopup() { pop.classList.remove('show'); setCookie('elaya_pop', '1', 30); }
    var cb = document.getElementById('pop-close'); if (cb) cb.addEventListener('click', closePopup);
    var sk = document.getElementById('pop-skip');  if (sk) sk.addEventListener('click', closePopup);
    pop.addEventListener('click', function (e) { if (e.target === pop) closePopup(); });
    document.querySelectorAll('.popup-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll('.popup-tab').forEach(function (t) { t.classList.remove('on'); });
        this.classList.add('on');
        document.querySelectorAll('.popup-form').forEach(function (f) { f.style.display = 'none'; });
        var tf = document.getElementById('pop-form-' + this.dataset.tab); if (tf) tf.style.display = 'block';
      });
    });
    document.querySelectorAll('.popup-form').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); closePopup(); });
    });
  })();

  /* ── Collection sort ── */
  var sortSel = document.getElementById('sort-select');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── Footer accordion (mobile only) ── */
  document.querySelectorAll('.footer-col-heading').forEach(function(heading){
    heading.addEventListener('click', function(){
      if (window.innerWidth > 768) return;
      var col = this.closest('.footer-link-col');
      col.classList.toggle('open');
    });
  });

  window.toggleTab = function(heading) {
    if (window.innerWidth > 768) return;
    var panel = heading.closest('.tab-panel');
    panel.classList.toggle('open');
  };

}); /* end DOMContentLoaded */